<template>
  <div class="grid_card mb-5">
    <v-card class="menu_team flex-grow-1 text-center mr-1">
      <router-link class="menu_team_link" to="/creditor/reportdebtor">
        <div class="menu_team_img">
          <img src="@/assets/data_creditor.png">
        </div>
        <div>
          รายงานลูกหนี้
        </div>
      </router-link>
    </v-card>
    <v-card class="menu_team flex-grow-1 text-center ml-1 mr-1">
      <router-link class="menu_team_link" to="/creditor/transferfromdebtor">
        <div class="menu_team_img">
          <img src="@/assets/money_creditor.png">
        </div>
        <div>
          การชำระเงินจากลูกหนี้
        </div>
      </router-link>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "MenuDebtor",
}
</script>
<style scoped>
.menu_team>.menu_team_link {
  color: #565656;
  padding: 10px 15px 10px 15px;
  line-height: 1.45;
  transition: padding 0.35s ease 0s !important;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  outline: none;
  background-color: transparent;
  border-radius: 4px;
  text-decoration: none;
  font-size: 20px;
}

.router-link-active,
.menu_team>.menu_team_link:hover {
  color: #fff !important;
  background-image: linear-gradient(to right, #8cc63e, #91c657, #9cc66d)!important;
  transition: 0.1s !important;
  border-radius: 4px;
  font-weight: 400;
}

.menu_team_img {
  margin: auto;
  width: 50px;
}

.menu_team_img>img {
  max-width: 100%;
}
.grid_card {
  display: flex;
  justify-content: space-between;
}
@media only screen and (max-width: 500px){
  .grid_card {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
</style>
